// extracted by mini-css-extract-plugin
export default {"xs":"320px","sm":"375px","md":"768px","lg":"1024px","xlg":"1366px","headerHeight":"65px"};